import React, { useEffect, useRef } from "react";
import QRCodeStyling from "qr-code-styling";
import "../styles/QRCodePage.css"; // Importa o CSS personalizado

const StyledQRCode = () => {
  const qrCodeRef = useRef(null);
  const qrCodeInstance = useRef(null); // Armazena a instância do QR Code

  useEffect(() => {
    if (!qrCodeInstance.current) {
      qrCodeInstance.current = new QRCodeStyling({
        width: 3000, // Largura total
        height: 3000, // Altura total
        data: "https://rondago.com.br", // URL ou dados do QR Code
        margin: 200, // Margem externa de ~1cm (em px)
        dotsOptions: {
          color: "#000", // Cor dos pontos
          type: "square", // Estilo de pontos
        },
        cornersSquareOptions: {
          color: "#000", // Cor das bordas quadradas
          type: "square", // Formato das bordas
        },
        cornersDotOptions: {
          color: "#000", // Cor dos pontos nas bordas
          type: "square", // Tipo de preenchimento nas bordas
        },
        backgroundOptions: {
          color: "#ffffff", // Cor de fundo branco
        },
        imageOptions: {
          crossOrigin: "anonymous",
          margin: 20, // Margem ao redor do logo
          imageSize: 0.75, // Aumenta o tamanho do logo para ~25% do QR Code
        },
      });
    }

    // Renderizar o QR Code no elemento
    if (qrCodeRef.current && qrCodeInstance.current) {
      qrCodeInstance.current.append(qrCodeRef.current);
    }
  }, []);

  return (
    <div className="qrcode-container">
      <h1>QR Code Estilizado</h1>
      <div className="qrcode-wrapper" ref={qrCodeRef} />
    </div>
  );
};

export default StyledQRCode;
